import z from 'zod';
import { DBLegacyTopicGroupColorSchema, type LegacyTopicGroupSchema } from './schemas';

type LegacyTopicGroupField = keyof z.infer<typeof LegacyTopicGroupSchema>;

export const DEFAULT_LEGACY_TOPIC_GROUP_COLOR: z.infer<typeof DBLegacyTopicGroupColorSchema> =
  '#0c374d';

const listAttributes = [
  'id',
  'subject',
  'code',
  'label',
  'badgeLabel',
  'color',
  'topics',
] as const satisfies readonly LegacyTopicGroupField[];

const getAttributes = [...listAttributes] as const satisfies readonly LegacyTopicGroupField[];

const updateAttributes = [
  'label',
  'badgeLabel',
  'color',
] as const satisfies readonly LegacyTopicGroupField[];

export const LegacyTopicGroupAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
